/**
 * Normalise a food name into a stable slug used as the DynamoDB sort-key id.
 *
 * This MUST stay byte-for-byte identical to scraper/src/slug.mjs: the scraper
 * writes ingredient records keyed by this slug, and this client looks them up
 * by normalising menu/menu-HTML names the same way and doing a direct GetItem.
 * Duplicated (rather than imported) only to avoid a cross-workspace import.
 *
 *   "Creamy Blueberry Oats "  ->  "creamy-blueberry-oats"
 *   "Beef & Black Bean"       ->  "beef-black-bean"
 */
export function slugifyName(name) {
  return String(name)
    .normalize('NFKD') // split accented chars so diacritics can be stripped
    .replace(/[\u0300-\u036f]/g, '') // remove diacritic marks
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // any run of non-alphanumerics -> single hyphen
    .replace(/^-+|-+$/g, ''); // trim leading/trailing hyphens
}
